import { PageHeader } from "./page-header";

export class Page<T> {
    public paging: PageHeader;
    public items: T[];
}